export const it_todo= {
    title: 'To Do',
    list_title: 'La tua to do List',
    label_description: 'Da fare',
    question_title: 'Conferma cancellazione',
    question: 'Sei sicuro di voler cancellare questo "To Do"?',
    label_scadenza:'Scadenza',
    label_assegna:'Assegna a:',
    label_aggiungi:'Aggiungi',

    'popover_todo_title': 'La To Do list',
    'popover_todo_content' : '<p>Inserisci le attività da svolgere e condividile con il tuo team.                   </p>\n'

};
